import styled from 'styled-components';

import { Typography } from '@libs/components';

export const ContentWrapper = styled.div`
  padding: 1.2rem 0;

  text-align: center;
  ${({ theme }) => theme.media.tabletL`
    padding: 2rem 0;
  `};
`;

export const CustomTypography = styled(Typography)`
  margin-left: 0.5rem;
`;
